// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/cotizador',
    name: 'cotizador',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/cotizador/Cotizador.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
  {
    path: '/cotizador-favorite',
    name: 'cotizador-favorite',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/cotizador/Favorite.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
  {
    path: '/view-details',
    name: 'view-details',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/cotizador/ViewDetails.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
]

export default formTable
